<template>
    <div>
        <div class="tenantMain position-relative justify-content-center"  v-if="!is_error">
            <div class="tenantCard lmu tenantForm tenantLogin">
                <div class="logo text-center mb-30">
                    <img src="/img/tenants-logo-small.png" alt="">
                </div>
                <div class="tenantGuest">
                    <b-row>
                        <b-col md="12" class="mb-3">
                            <gofix-text-field 
                                classLabel="flex-120"
                                label="Project Name" 
                                oneline>
                                {{ Item && Item.project && Item.project.contract_title ? Item.project.contract_title : '' }}
                            </gofix-text-field>
                        </b-col>
                        <b-col md="12" class="mb-3">
                            <gofix-text-field  
                                classLabel="flex-120"
                                label="Company Name" 
                                oneline>
                                {{ Item && Item.project && Item.project.supplier ? Item.project.supplier.name : '' }}
                            </gofix-text-field>
                        </b-col>
                        <b-col md="12" class="mb-3">
                            <gofix-text-field  
                                classLabel="flex-120"
                                label="Date" 
                                oneline>
                                {{ Item && Item.date ? $options.filters.formatDatebyMoment(Item.date, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}
                            </gofix-text-field>
                        </b-col>
                        <b-col md="12" class="mb-3">
                            <gofix-text-field  
                                classLabel="flex-120"
                                label="Venue" 
                                oneline>
                                {{ Item && Item.venue && Item.venue ? Item.venue : '' }}
                            </gofix-text-field>
                        </b-col>
                        <b-col md="12" class="mb-3">
                            <gofix-text-field  
                                classLabel="flex-120"
                                label="Topics" 
                                oneline>
                                {{ Item && Item.topic_names ? Item.topic_names : '' }}
                            </gofix-text-field>
                        </b-col>
                        <b-col md="12">
                            <gofix-form-input 
                                label="Name" 
                                v-model="item.name">
                            </gofix-form-input>
                        </b-col>
                        <b-col md="12">
                            <gofix-form-input 
                                label="IC/FIN"
                                v-model="item.ic_fin">
                            </gofix-form-input>
                            <!-- <gofix-form-input-number 
                                label="IC/FIN"
                                v-model="item.ic_fin" 
                                :include-thousands-separator="false" 
                                :allowDecimal="false" 
                                :integer-limit="9"
                                class="gofixInputNoMinWidth">
                            </gofix-form-input-number> -->
                        </b-col>
                        <!-- <b-col md="12">
                            <gofix-form-input 
                                label="Department" 
                                v-model="item.department">
                            </gofix-form-input>
                        </b-col> -->
                        <!-- <b-col md="12">
                            <gofix-form-input 
                                label="Company" 
                                v-model="item.company">
                            </gofix-form-input>
                        </b-col> -->
                    </b-row>
                </div>
                <div class="text-center mt-3">
                    <gofix-button class="mw-250 mb-3 mx-2" label="SUBMIT" large @click="showModalSignature"></gofix-button>
                </div>
            </div>
            <b-modal :no-close-on-backdrop="true" id="modal-bacsicInfo" title="Signature" hide-footer :centered="true" v-model="modals.signature.open">
                <VueSignaturePad id="signature" width="300px" height="400px" ref="signaturePad" />
                <b-button-group class="d-block text-right">
                    <gofix-button label="SUBMIT" @click="save" :loading="loading_save" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
        </div>
        <div id="error-page" v-else>
            <div class="content">
                <h2 class="header" data-text="404">404</h2>
                <h4 data-text="Opps! Page not found">Opps! Page not found</h4>
                <p>Sorry, the page you're looking for doesn't exist.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    components: {
    },
    name: 'briefing-register-form',
    data() {
        return {
            width: '500px',
            height: '500px',
            item: {
                name: null,
                ic_fin: null,
                department: null,
                company: null
            },
            modals: {
                signature: {
                    open: false
                }
            },
            loading_save: false,
            timer_save: false,
            is_error: false
        }
    },
    computed: {
        ...mapGetters({
            Item: 'SafetyAppController/safetyTraining',
        })
    },
    watch: {
        
    },
    methods: {
        showModalSignature() {
            const is_validate = this.validationData(this.item);
            if(is_validate) return

            if(this.item.ic_fin && this.item.ic_fin.length < 4) {
                this.$alertNotification(`IC/FIN must be at least 4 characters`, "danger");
                return;
            }

            this.modals.signature.open = true;
        },
        validationData(data) {
            const validate_fields = [
                { key: 'name', name: 'Name'},
                { key: 'ic_fin', name: 'IC/FIN'},
                // { key: 'department', name: 'Department'},
                // { key: 'company', name: 'Company'},
            ]

            let flag = false
            for (const field of validate_fields) {
                if(!data[field.key]) {
                    flag = true
                    this.$alertNotification(`${field.name} is required`, "danger");
                    break
                }
            }

            return flag
        },
        async base64ToFile(base64String, filename) {
            // const response = await fetch(base64String);
            // const blob = await response.blob();
            // return new File([blob], filename, { type: mimeType });

            const arr = base64String.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);

            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }

            return new File([u8arr], filename, { type: mime });
        },
        save() {
            if (this.timer_save) {
                    clearTimeout(this.timer_save);
                    this.timer_save = null;
                }
                this.timer_save = setTimeout(async () => {
                    const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
                    if(isEmpty) {
                        return this.$alertNotification("Please sign to continue", "danger");
                    }

                    if(this.loading_save) return;
                    this.loading_save = true;

                    let objeClone = Object.assign({
                        safety_induction_training_id: this.$route.query.briefing_id,
                    }, this.item);

                    objeClone.company = this.Item && this.Item.project && this.Item.project.supplier ? this.Item.project.supplier.name : ''

                    const time = Math.floor((new Date()).getTime() / 1000);
                    const filename = `signature_${time}.png`;
                    // const mimeType = "image/png";

                    objeClone.signatures = await this.base64ToFile(data, filename)
    
                    this.$store.dispatch(`SafetyAppController/registerWorker`, objeClone)
                    .then(async response => {
                        this.loading_save = this.modals.signature.open = false;
                        if(response.code && response.message) {
                            this.$alertNotification(response.message, "danger");
                            return;
                        }
                        this.item = Object.assign(this.item, {
                            name: null,
                            ic_fin: null,
                            department: null,
                            company: null
                        })
                        this.$alertNotification('Registration successful', "success");
                    })
                    .catch(err => {
                        console.log(err)
                        this.isSave = false;
                        this.loading_save = false;
                        if( err.response.data.error && err.response.data.error.message ) {
                            this.$alertNotification(err.response.data.error.message, "danger"); 
                        }
                    })

                }, 200);
        },
        getItem() {
            this.$store.dispatch( 'SafetyAppController/getSafetyInductionTrainingItem', this.$route.query.briefing_id)
        },
    },
    
    mounted: async function() {
        this.$root.$on('bv::modal::shown', (bvEvent, modalId) => {
            this.$nextTick(() => {
                this.$refs.signaturePad.resizeCanvas();
            });
        })
    },
    created() {
        if (
            !this.$route.query.hasOwnProperty("briefing_id") ||
            isNaN(this.$route.query.briefing_id)
        ) {
            this.is_error = true
        } else {
            this.getItem();
        }
    }
}
</script>

<style lang="scss">
    .flex-120 {
        flex: 0 0 120px;
    }
    #signature {
        border: double 3px transparent;
        border-radius: 5px;
        background-image: linear-gradient(white, white),
            radial-gradient(circle at top left, #4bc5e8, #9f6274);
        background-origin: border-box;
        background-clip: content-box, border-box;
        margin: 0 auto;
    }
    #error-page{
        position: absolute;
        top: 10%;
        left: 15%;
        right: 15%;
        bottom: 10%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        box-shadow: 0px 5px 10px rgba(0,0,0,0.1);
    }
    #error-page .content{
        max-width: 600px;
        text-align: center;
    }
    .content h2.header{
        font-size: 18vw;
        line-height: 1em;
        position: relative;
    }
    .content h2.header:after{
        position: absolute;
        content: attr(data-text);
        top: 0;
        left: 0;
        right: 0;
        background: -webkit-repeating-linear-gradient(-45deg, #71b7e6, #69a6ce, #b98acc, #ee8176, #b98acc, #69a6ce, #9b59b6);
        background-size: 400%;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-shadow: 1px 1px 2px rgba(255,255,255,0.25);
        animation: animate 10s ease-in-out infinite;
    }
    @keyframes animate {
        0%{
            background-position: 0 0;
        }
        25%{
            background-position: 100% 0;
        }
        50%{
            background-position: 100% 100%;
        }
        75%{
            background-position: 0% 100%;
        }
        100%{
            background-position: 0% 0%;
        }
    }
    .content h4{
        font-size: 1.5em;
        margin-bottom: 20px;
        text-transform: uppercase;
        color: #000;
        font-size: 2em;
        max-width: 600px;
        position: relative;
    }
    .content h4:after{
        position: absolute;
        content: attr(data-text);
        top: 0;
        left: 0;
        right: 0;
        text-shadow: 1px 1px 2px rgba(255,255,255,0.4);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .content p{
        font-size: 1.2em;
        color: #0d0d0d;
    }
    .content .btns{
        margin: 25px 0;
        display: inline-flex;
    }
    .content .btns a{
        display: inline-block;
        margin: 0 10px;
        text-decoration: none;
        border: 2px solid #69a6ce;
        color: #69a6ce;
        font-weight: 500;
        padding: 10px 25px;
        border-radius: 25px;
        text-transform: uppercase;
        transition: all 0.3s ease;
    }
    .content .btns a:hover{
        background: #69a6ce;
        color: #fff;
    }
    @media screen and (min-width: 768px) {
        .tenantCard {
            max-width: 800px;
        }
    }

    @media screen and (max-width: 768px) {
        .gofixButton.gofixButtonNoBorder:hover {
            color: #F05600 !important;
            border: none !important;
        }
    }
</style>